import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReplaySubject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HistoricoDeVendasFilterService {

  historicoDeVendasFilter$$ = new ReplaySubject<{
    dataInicial: string;
    dataFinal: string;
    orcamento: string;
    pedido: string;
    filial: string;
    cliente: string;
    vendedor: string;
  }>(1);

  change_filter$$ = new ReplaySubject<{
    dataInicial: string;
    dataFinal: string;
    orcamento: string;
    pedido: string;
    filial: string;
    cliente: string;
    vendedor: string;
  }>(1)

  courrent_filter = {
    dataInicial: '',
    dataFinal: '',
    orcamento: '',
    pedido: '',
    filial: '',
    cliente: '',
    vendedor: '',
  }

  FINAL_DATE = new Date();
  START_DATE = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date;
  };
  filterGroup = new FormGroup({
    dataInicial: new FormControl<Date | null>(null),
    dataFinal: new FormControl<Date | null>(null),
    filial: new FormControl(''),
    pedido: new FormControl('', [Validators.max(2147483646)]),
    orcamento: new FormControl('', [Validators.max(2147483646)]),
    cliente: new FormControl<string | number>(''),
    vendedor: new FormControl(''),
  });

}
